import type { SeoContentSection, SiteLocale } from '@/lib/site-locale';
import { withSsrDependencyTiming } from '@/lib/ssr-timing';

interface LocaleAvailabilityResponse {
  section: SeoContentSection;
  locales: SiteLocale[];
  counts: Record<SiteLocale, number>;
}

export const useSeoLocaleAvailability = () => {
  const fetchLocaleAvailability = async (
    section: SeoContentSection
  ): Promise<LocaleAvailabilityResponse> => {
    try {
      return await withSsrDependencyTiming(
        'api:seo:locale-availability',
        () =>
          $fetch<LocaleAvailabilityResponse>('/api/seo/locale-availability', {
            query: { section },
          }),
        {
          url: `/api/seo/locale-availability?section=${encodeURIComponent(section)}`,
          kind: 'internal',
        }
      );
    } catch (error) {
      console.error(`Error fetching locale availability for ${section}:`, error);
      return {
        section,
        locales: [],
        counts: { en: 0, ja: 0, ko: 0, es: 0 },
      };
    }
  };

  const fetchAvailableLocales = async (section: SeoContentSection): Promise<SiteLocale[]> => {
    return (await fetchLocaleAvailability(section)).locales;
  };

  return { fetchAvailableLocales, fetchLocaleAvailability };
};
